export default __webpack_public_path__ + "candle-chart-2805bbc675d8f6b9df301233fa826172.svg";